<script lang="ts" setup>
import { computed } from 'vue'
import { brand } from '@/config/brands'

const props = defineProps<{
  visible: boolean
  countdown: number
  countdownText: string
}>()

const emit = defineEmits<{
  (e: 'click'): void
}>()

const floatingImage = `/images/${brand}/retention_floating.png`

const countdownParts = computed(() => {
  const [min, sec] = (props.countdownText || '').split(':').map(s => s.trim())
  return { min: min || '00', sec: sec || '00' }
})

const isVisible = computed(() => props.visible && props.countdown > 0)
</script>

<template>
  <div
    v-show="isVisible"
    class="retention-floating-btn"
    @click="emit('click')"
  >
    <img :src="floatingImage" alt="" class="floating-icon">
    <div class="floating-countdown">
      <span class="cd-box">{{ countdownParts.min }}</span>
      <span class="cd-colon">:</span>
      <span class="cd-box">{{ countdownParts.sec }}</span>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.retention-floating-btn {
  position: fixed;
  right: 12px;
  bottom: 280px;
  width: 66px;
  z-index: 99;
  cursor: pointer;
  animation: float-in 0.3s ease-out;
}

.floating-icon {
  width: 100%;
  display: block;
}

.floating-countdown {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 6%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 3px;
}

.cd-box {
  min-width: 14px;
  padding: 0 3px;
  border-radius: 3px;
  background: #fff;
  color: #ff6a00;
  font-size: 10px;
  font-weight: 800;
  line-height: 1.4;
  text-align: center;
}

.cd-colon {
  color: #ff5a1f;
  font-size: 10px;
  font-weight: 800;
  line-height: 1;
}

@keyframes float-in {
  from {
    opacity: 0;
    transform: scale(0.5) translateY(20px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}
</style>
